
/* eslint-disabled */
import { defineComponent, reactive } from 'vue'
import { Icon } from 'scvant';
import reportComfirmTitle from '../title.vue'

interface State {
    isShowMore: boolean;
}

export default defineComponent({
    name: 'reportItemEcu',
    setup() {
        let state: State = reactive({
            isShowMore: false
        });
        function showOrHide (){
            state.isShowMore = !state.isShowMore;
        }
        return {
            state,
            showOrHide
        }
    },
    computed: {
        ecuState (){
            let state = '';
            switch (this.renderData as any) {
                case 1:
                    state = '不支持ECU检测';
                    break;
                case 2: 
                    state = '已查到故障码';
                    break;
                default:
                    state = '未查到故障码';
                    break;
            }
            return state;
        }
    },
    components: {
        [Icon.name]: Icon,
        reportComfirmTitle
    },
    props: {
        renderData: {
            type: Number,
            default: () => {
                return -1
            }
        },
        options: {
            type: String,
            default: () => {
                return ''
            }
        }
    }
})
